import React from "react";
import { Parcours } from "../../../modules/academy/parcours/models/Parcours";

interface ParcoursHeaderProps {
  parcours: Parcours;
  progressionPercent: number;
  isGuest: boolean;
  onStart: () => void;
  onContinue: () => void;
}

export function ParcoursHeader({
  parcours,
  progressionPercent,
  isGuest,
  onStart,
  onContinue,
}: ParcoursHeaderProps) {
  const hasProgress = progressionPercent > 0;
  return (
    <section className="rounded-2xl border shadow-sm p-5 bg-white dark:bg-slate-900 dark:border-slate-700 space-y-3">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div>
          <p className="text-[11px] uppercase tracking-wide text-slate-500 dark:text-slate-400">Parcours</p>
          <h1 className="text-2xl font-semibold">{parcours.title}</h1>
          <p className="text-sm text-slate-600 dark:text-slate-300">{parcours.description}</p>
          <div className="flex gap-2 text-xs text-slate-500 dark:text-slate-400 mt-2 flex-wrap">
            <span>Audience: {parcours.audience}</span>
            <span>Niveau: {parcours.level}</span>
            <span>Durée: {parcours.duration} min</span>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex flex-col items-end">
            <span className="text-xs text-slate-500 dark:text-slate-400">Progression</span>
            <span className="text-lg font-semibold">{progressionPercent}%</span>
          </div>
          <div className="h-2 w-32 rounded-full bg-slate-200 dark:bg-slate-800 overflow-hidden">
            <div
              className="h-full bg-blue-500"
              style={{ width: `${Math.min(Math.max(progressionPercent, 0), 100)}%` }}
            />
          </div>
        </div>
      </div>

      <div className="space-y-1">
        <h3 className="text-sm font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
          Objectifs
        </h3>
        <ul className="list-disc list-inside text-sm text-slate-700 dark:text-slate-200 space-y-1">
          {parcours.goals.map((g) => (
            <li key={g}>{g}</li>
          ))}
        </ul>
      </div>

      {isGuest && (
        <p className="text-[11px] text-slate-500">
          Mode invité : connectez-vous pour sauvegarder votre progression.
        </p>
      )}

      <div className="flex gap-2">
        <button
          type="button"
          onClick={hasProgress ? onContinue : onStart}
          className="px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700"
        >
          {hasProgress ? "Continuer" : "Commencer le parcours"}
        </button>
      </div>
    </section>
  );
}
